import { AxiosInstance } from "axios";
import { ApiService } from '../models/Api.model';
import { IBCheckModal } from "../interfaces/Compliance/IBCheckModal";

enum BCheckServiceEnum {
  getBcheckByTradeId = "/trade/"
}

export class BCheckService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/bcheck");
  }
  public getBcheckByTradeId = async (tradeId: number): Promise<IBCheckModal[]> => await this.GET(BCheckServiceEnum.getBcheckByTradeId + tradeId);
}



// WEBPACK FOOTER //
// ./src/services/api/BCheck.service.ts